var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: { type: "primary", size: "small", icon: "el-icon-back" },
          on: {
            click: function($event) {
              return _vm.$router.back(-1)
            }
          }
        },
        [_vm._v("返回")]
      ),
      _vm.active === 0 ? _c("UserForm", { on: { next: _vm.next } }) : _vm._e(),
      _vm.active === 1
        ? _c("NotaryForm", { on: { next: _vm.next } })
        : _vm._e(),
      _vm.active === 2 ? _c("SelectSignature") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }